export const menagementQuestions = {
	governanceResponsibilities: {
		id: "governanceResponsibilities",
		steps: {
			"1": { // 2.1
				id: "1",
				type: "radio",
				label: "Na sua empresa existem projetos de gestão de água que tenham o envolvimento da alta administração?",
				options: [
					{
						label: "a) Sim, existem projetos de gestão de água implementados na empresa e há envolvimento da alta administração.", 
						id: "A"
					},
					{
						label: "b) Sim, existem projetos de gestão de água implementados na empresa, entretanto não há envolvimento da alta administração.", 
						id: "B"
					},
					{
						label: "c) Existem projetos de gestão de água, porém estão na fase Inicial e ainda não foram implementados.", 
						id: "C"
					},
					{
						label: "d) Não existe projeto de gestão de água.", 
						id: "D"
					},
				]
			},
			"2": { // 2.2
				id: "2",
				type: "radio",
				label: "Existe na empresa um comitê que se reúne periodicamente para discutir temas relacionados à água?",
				options: [
					{
						label: "a) Sim, existe na empresa um comitê/grupo de executivos / gerentes, que se reúne para discutir o tema da água com frequência anual ou inferior.", 
						id: "A"
					},
					{
						label: "b) Sim, existe na empresa um comitê/grupo de executivos / gerentes, que se reúne para discutir o tema da água somente quando há situações extremas de escassez hídrica ou emergências.", 
						id: "B"
					},
					{
						label: "c) Não há um grupo de gestores que se reúne periodicamente, porém, toda a gestão de água está centralizada em uma única gerência, que controla mensalmente os indicadores de consumo e volume de efluentes lançado.", 
						id: "C"
					},
					{
						label: "d) Não, apenas técnicos das áreas de manutenção e operação lidam com o tema diretamente com seus gerentes, somente quando há necessidade de manutenção.", 
						id: "D"
					},
				]
			},
			"3": { // 2.3
				id: "3",
				type: "radio",
				label: "A empresa participa de algum programa de proteção / gestão/ monitoramento de bacias hidrográficas, rios, córregos, lagos ou nascentes?",
				options: [
					{
						label: "a) Sim, participamos de programas de proteção / gestão / monitoramento de bacias hidrográficas, rios, córregos, lagos ou nascentes, utilizados pela empresa, atuando além de nossos limites operacionais.", 
						id: "A"
					},
					{
						label: "b) Sim, desenvolvemos ações de proteção / gestão / monitoramento de córregos, lagos ou nascentes, que estão dentro dos limites operacionais de nossa empresa.", 
						id: "B"
					},
					{
						label: "c) Não, mas temos planos de participação em programas de proteção, gestão, monitoramento de bacias hidrográficas, rios, córregos, lagos ou nascentes.", 
						id: "C"
					},
					{
						label: "d) Não existe planos de participação em programas de proteção/ gestão/ monitoramento de bacias hidrográficas, rios, lagos, córregos ou nascentes.", 
						id: "D"
					},
				]
			},
			"3-1": { // 2.3.1
				id: "3-1",
				type: "textArea",
				label: "Descrever qual programa de proteção /gestão / monitoramento é realizado.",
				options: [
					{id: "description", label: "Resposta."}
				]
			},
			"4": { // 2.4
				id: "4",
				type: "radio",
				label: "Existe na empresa projetos de compensação/mitigação de impactos ambientais associados ao uso da água?",
				options: [
					{
						label: "a) Sim, existe na empresa projetos de compensação /mitigação de impactos ambientais.", 
						id: "A"
					},
					{
						label: "b) Sim, existe na empresa projetos de compensação / mitigação, porém não foram implementados na empresa.", 
						id: "B"
					},
					{
						label: "c) Não, porém existem planos para desenvolver.", 
						id: "C"
					},
					{
						label: "d) Não existe na empresa projetos de compensação /mitigação de impactos ambientais.", 
						id: "D"
					},
				]
			},
			"4-1": { // 2.4.1
				id: "4-1",
				type: "textArea",
				label: "- Descrever qual projeto de compensação / mitigação é realizado.",
				options: [
					{id: "description", label: "Resposta."}
				]
			}
		}
	},
	businessPlanning: {
		id: "businessPlanning",
		steps: {
			"1": { // 2.5
				id: "1",
				type: "radio",
				label: "A empresa tenta identificar riscos e oportunidades relacionados à água?",
				options: [
					{
						label: "a) Sim, empresa considera o tema ''água'' no planejamento de negócio em todas as tomadas de decisões, identificando riscos e oportunidades associados à água dentro e fora dos limites operacionais. Os riscos associados à água são integrados no sistema de gestão de riscos corporativos da empresa. Diversas ações já foram implementadas para reduzir os riscos e maximizar as oportunidades.", 
						id: "A"
					},
					{
						label: "b) Sim , empresa identifica riscos e oportunidades dentro dos limites operacionais da organização e possui ações implementadas para minimizar os riscos e maximizar as oportunidades.", 
						id: "B"
					},
					{
						label: "c) Sim, a empresa identifica riscos e oportunidades relacionados a água nos processos, mas ainda não implementou ações.", 
						id: "C"
					},
					{
						label: "d) Não, a empresa não identifica riscos e oportunidades relacionados à água.", 
						id: "D"
					},
				]
			},
			"1-1": { // 2.4.1
				id: "1-1",
				type: "textArea",
				label: "Descreva como a empresa identifica os riscos e oportunidades e quais ações foram implementadas.",
				options: [
					{id: "description", label: "Resposta."}
				]
			}
		}
	}
};


// WEBPACK FOOTER //
// src/models/lib/questions/menagementQuestions.js